<template>
  <router-view>
    <div class="header_dark" :class="{'header-dark_fixed': this.isHeaderScrolled}">
      <div ref="nav-header_bg" class="header__bg"></div>
      <nav class="nav-container">
        <div class="container">
          <nav>
            <div class="flex justify-between align-center">
              <div class="navbar-logo">
                <img class="logo" src="../assets/logo_dark.svg" alt="logo webmil" @click="$router.push('/')">
                
                <div class="internationalization_mobile flex align-center">
                  <button :class="{'internationalization-button__active': this.$root.$i18n.locale === button.name}" v-for="(button) in internationalizationButtons" :key="button.id" @click="setWebsiteLanguage(button.name)" :ref="'internationalization-button' + button.id">
                    {{button.name.toUpperCase()}}
                  </button>
                </div>
              </div>
              <div class="mobile_messagers">
                <a class="viber_btn" href="https://wa.me/380668089011" >
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 24L2.687 17.837C1.646 16.033 1.099 13.988 1.1 11.891C1.103 5.335 6.438 0 12.993 0C16.174 0.001 19.16 1.24 21.406 3.488C23.651 5.736 24.887 8.724 24.886 11.902C24.883 18.459 19.548 23.794 12.993 23.794C11.003 23.793 9.042 23.294 7.305 22.346L1 24ZM7.597 20.193C9.273 21.188 10.873 21.784 12.989 21.785C18.437 21.785 22.875 17.351 22.878 11.9C22.88 6.438 18.463 2.01 12.997 2.008C7.545 2.008 3.11 6.442 3.108 11.892C3.107 14.117 3.759 15.783 4.854 17.526L3.855 21.174L7.597 20.193ZM18.984 14.729C18.91 14.605 18.712 14.531 18.414 14.382C18.117 14.233 16.656 13.514 16.383 13.415C16.111 13.316 15.913 13.266 15.714 13.564C15.516 13.861 14.946 14.531 14.773 14.729C14.6 14.927 14.426 14.952 14.129 14.803C13.832 14.654 12.874 14.341 11.739 13.328C10.856 12.54 10.259 11.567 10.086 11.269C9.913 10.972 10.068 10.811 10.216 10.663C10.35 10.53 10.513 10.316 10.662 10.142C10.813 9.97 10.862 9.846 10.962 9.647C11.061 9.449 11.012 9.275 10.937 9.126C10.862 8.978 10.268 7.515 10.021 6.92C9.779 6.341 9.534 6.419 9.352 6.41L8.782 6.4C8.584 6.4 8.262 6.474 7.99 6.772C7.718 7.07 6.95 7.788 6.95 9.251C6.95 10.714 8.015 12.127 8.163 12.325C8.312 12.523 10.258 15.525 13.239 16.812C13.948 17.118 14.502 17.301 14.933 17.438C15.645 17.664 16.293 17.632 16.805 17.556C17.376 17.471 18.563 16.837 18.811 16.143C19.059 15.448 19.059 14.853 18.984 14.729Z" fill="currentColor" />
                  </svg>
                </a>
                <a class="tg_btn" href="https://t.me/+380668089011">
                  <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.64987 8.60987C8.09231 5.78741 12.3883 3.92667 14.5378 3.02765C20.675 0.460774 21.9503 0.0148807 22.7815 0.000156987C22.9643 -0.00308132 23.3731 0.0424773 23.6379 0.25852C23.8614 0.440943 23.9229 0.687369 23.9524 0.860326C23.9818 1.03328 24.0185 1.42728 23.9893 1.73514C23.6568 5.249 22.2177 13.7762 21.4856 17.7118C21.1758 19.3771 20.5658 19.9354 19.9753 19.9901C18.6919 20.1088 17.7174 19.1372 16.4744 18.3179C14.5294 17.0358 13.4305 16.2377 11.5425 14.9867C9.36064 13.5408 10.7751 12.7462 12.0185 11.4475C12.344 11.1076 17.9985 5.93584 18.1079 5.46668C18.1216 5.40801 18.1343 5.18929 18.0051 5.0738C17.8759 4.95831 17.6851 4.9978 17.5475 5.02921C17.3524 5.07373 14.2452 7.1389 8.22584 11.2247C7.34386 11.8337 6.545 12.1304 5.82924 12.1149C5.04018 12.0977 3.52233 11.6663 2.39397 11.2974C1.00999 10.8451 -0.0899676 10.6059 0.00581422 9.83761C0.0557033 9.43745 0.603723 9.0282 1.64987 8.60987Z" fill="currentColor"/>
                  </svg>
                </a>
              </div>
              <div @click="openMenu()" class="navbar-burger" id="dropdownMenuIcon-js">
                <div class="dropdown-menu_icon dropdown-menu_icon-black" id="openIcon">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>

              <div class="dropdown-menu_list dropdown-menu_list-light flex" id="dropdownMenuList-js">
                <ul>
                  <li class="nav-item" v-for="(menu, index) in menuHeaderList" :key='index'>
                    <a @click="goToPage(menu.path)" class="navbar-link" aria-current="page">{{ $t(menu.name) }}</a>
                  </li>
                  <li>
                    <Link class="navbar-link" :to="blogUrl">{{ $t('main_page.header.nav[2]') }}</Link>
                  </li>
                </ul>

                <div v-for="(project, i) in cases" :key="i">
                  <a @click="goToPage(project.path)" class="nav__btn btn__general btn__general-black" aria-current="page">{{ $t(project.name) }}
                    <svg width="31" height="8" viewBox="0 0 31 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M30.3536 4.35355C30.5488 4.15829 30.5488 3.84171 30.3536 3.64645L27.1716 0.464466C26.9763 0.269204 26.6597 0.269204 26.4645 0.464466C26.2692 0.659728 26.2692 0.976311 26.4645 1.17157L29.2929 4L26.4645 6.82843C26.2692 7.02369 26.2692 7.34027 26.4645 7.53553C26.6597 7.7308 26.9763 7.7308 27.1716 7.53553L30.3536 4.35355ZM0 4.5H30V3.5H0V4.5Z" fill="#2E3139"/>
                    </svg>
                  </a>
                </div>
                <div class="desktop_messagers">
                  <a class="viber_btn" href="https://wa.me/380668089011" >
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 24L2.687 17.837C1.646 16.033 1.099 13.988 1.1 11.891C1.103 5.335 6.438 0 12.993 0C16.174 0.001 19.16 1.24 21.406 3.488C23.651 5.736 24.887 8.724 24.886 11.902C24.883 18.459 19.548 23.794 12.993 23.794C11.003 23.793 9.042 23.294 7.305 22.346L1 24ZM7.597 20.193C9.273 21.188 10.873 21.784 12.989 21.785C18.437 21.785 22.875 17.351 22.878 11.9C22.88 6.438 18.463 2.01 12.997 2.008C7.545 2.008 3.11 6.442 3.108 11.892C3.107 14.117 3.759 15.783 4.854 17.526L3.855 21.174L7.597 20.193ZM18.984 14.729C18.91 14.605 18.712 14.531 18.414 14.382C18.117 14.233 16.656 13.514 16.383 13.415C16.111 13.316 15.913 13.266 15.714 13.564C15.516 13.861 14.946 14.531 14.773 14.729C14.6 14.927 14.426 14.952 14.129 14.803C13.832 14.654 12.874 14.341 11.739 13.328C10.856 12.54 10.259 11.567 10.086 11.269C9.913 10.972 10.068 10.811 10.216 10.663C10.35 10.53 10.513 10.316 10.662 10.142C10.813 9.97 10.862 9.846 10.962 9.647C11.061 9.449 11.012 9.275 10.937 9.126C10.862 8.978 10.268 7.515 10.021 6.92C9.779 6.341 9.534 6.419 9.352 6.41L8.782 6.4C8.584 6.4 8.262 6.474 7.99 6.772C7.718 7.07 6.95 7.788 6.95 9.251C6.95 10.714 8.015 12.127 8.163 12.325C8.312 12.523 10.258 15.525 13.239 16.812C13.948 17.118 14.502 17.301 14.933 17.438C15.645 17.664 16.293 17.632 16.805 17.556C17.376 17.471 18.563 16.837 18.811 16.143C19.059 15.448 19.059 14.853 18.984 14.729Z" fill="currentColor" />
                    </svg>
                  </a>
                  <a class="tg_btn" href="https://t.me/+380668089011">
                    <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.64987 8.60987C8.09231 5.78741 12.3883 3.92667 14.5378 3.02765C20.675 0.460774 21.9503 0.0148807 22.7815 0.000156987C22.9643 -0.00308132 23.3731 0.0424773 23.6379 0.25852C23.8614 0.440943 23.9229 0.687369 23.9524 0.860326C23.9818 1.03328 24.0185 1.42728 23.9893 1.73514C23.6568 5.249 22.2177 13.7762 21.4856 17.7118C21.1758 19.3771 20.5658 19.9354 19.9753 19.9901C18.6919 20.1088 17.7174 19.1372 16.4744 18.3179C14.5294 17.0358 13.4305 16.2377 11.5425 14.9867C9.36064 13.5408 10.7751 12.7462 12.0185 11.4475C12.344 11.1076 17.9985 5.93584 18.1079 5.46668C18.1216 5.40801 18.1343 5.18929 18.0051 5.0738C17.8759 4.95831 17.6851 4.9978 17.5475 5.02921C17.3524 5.07373 14.2452 7.1389 8.22584 11.2247C7.34386 11.8337 6.545 12.1304 5.82924 12.1149C5.04018 12.0977 3.52233 11.6663 2.39397 11.2974C1.00999 10.8451 -0.0899676 10.6059 0.00581422 9.83761C0.0557033 9.43745 0.603723 9.0282 1.64987 8.60987Z" fill="currentColor"/>
                    </svg>
                  </a>
              </div>
                <div class="internationalization flex align-center">
                  <button :class="{'internationalization-button__active': this.$root.$i18n.locale === button.name}" v-for="(button) in internationalizationButtons" :key="button.id" @click="setWebsiteLanguage(button.name)" :ref="'internationalization-button' + button.id">
                    {{button.name.toUpperCase()}}
                  </button>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </nav>
    </div>
  </router-view>
</template>

<script>

import Link from "./Link";

export default {
  data() {
    return {
      menuHeaderList: [
        {name: 'main_page.header.nav[0]', path: '/cases/'},
        {name: 'main_page.header.nav[1]', path: '/work-approach/'}
      ],
      cases: [
        {name: 'main_page.header.button', path: '/contacts/'}
      ],
      internationalizationButtons: [
        {id: 1, name: 'en'},
        {id: 2, name: 'ua'}
      ],
      isHeaderScrolled: false
    }
  },
  computed: {
    blogUrl() {
      return this.$i18n.locale === 'en' 
        ? 'https://blog.webmil.eu/' 
        : 'https://blog-ua.webmil.eu/';
    }
  },
  components: {
     Link
  },
  methods: {
    openMenu() {
      let menuList = document.getElementById('dropdownMenuList-js')
      let openIcon = document.getElementById('openIcon')
      let body = document.querySelector("body");
      menuList.classList.toggle('open')
      openIcon.classList.toggle('icon-trigger')
      body.classList.toggle("lock")
    },
    goToPage(path){
      this.$router.push(path);
      let body = document.querySelector("body");
      let menuList = document.getElementById('dropdownMenuList-js')
      let openIcon = document.getElementById('openIcon')
      if(body.classList.contains("lock")){
        menuList.classList.remove('open')
        openIcon.classList.remove('icon-trigger')
        body.classList.remove("lock");
      }
    },
    reloadPage() {
      window.location.reload();
    },
    checkHeaderPosition(){
      if(!this.$refs["nav-header_bg"]){
        return false
      }

      if(window.scrollY > 0 && window.scrollY <= 100){
        this.isHeaderScrolled = true
        this.$refs["nav-header_bg"].style.opacity = "0.7"
      } else if (window.scrollY > 100 && window.scrollY <= 200) {
        this.isHeaderScrolled = true
        this.$refs["nav-header_bg"].style.opacity = "0.9"
      } else if (window.scrollY > 200){
        this.isHeaderScrolled = true
        this.$refs["nav-header_bg"].style.opacity = "1"
      } else {
        this.isHeaderScrolled = false
      }
    },
    setWebsiteLanguage(language){
      this.$root.$i18n.locale = language;
    }
  },
  mounted(){
    window.addEventListener("scroll", this.checkHeaderPosition);
  }
}
</script>

<style lang="scss">
@import "../base/styles/global";

.desktop_messagers{
  display: none;
  @media(min-width: 991px){
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-right: 20px;
  }
}

.mobile_messagers{
  display: none;
  @media(max-width: 991px){
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-right: 20px;
  }
}

.tg_btn, .viber_btn{
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover{
    color:#000;
  }
}
.viber_btn{
  margin-left: 10px;
}

.header_dark{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  .internationalization{
    .internationalization-button__active{
      font-weight: 700;
      color: #2E3139;
    }
    button{
      transition: 0.1s all;
      color: #83898B;
    }
  }

  .internationalization_mobile{
    .internationalization-button__active{
      font-weight: 700;
      color: #2E3139;
    }
    margin-left: 20px;
    button{
      transition: 0.1s all;
      color: #83898B;
      font-weight: 400;
    }
  }
}

.header-dark_fixed{
  width: 100%;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  transition: 0.7s all;

  .header__bg{
    background: #fff;
  }

  .nav-container{
    padding: 27px 0px;

    @media (max-width: 991px) {
      padding: 20px 0px;
    }

    @media(max-width: 575px){
      padding: 16px 0px;
    }
  }
}


.nav-container{
  padding: 27px 0px;

  @media (max-width: 991px) {
    padding: 20px 0px;
  }

  @media(max-width: 575px){
    padding: 16px 0px;
  }
}

.navbar-logo{
  cursor: pointer;
  display: flex;
  align-items: center;
}

.ml-auto {
  margin-left: auto;
}

.navbar-collapse {
  @media (max-width: 768px) {
    background-color: black !important;
  }
}

.navbar-toggler {
  border: none !important;
  background-color: #191A1B;
}

a {
  font-size: 20px;
  line-height: 28px;
  color: #000;
}

.btn-contact {
  margin-left: 120px;
  border: 1px solid #fff;
  padding: 8px 70px 8px 20px;
}

.dropdown-menu_icon-black {
  span{
    @media (max-width: 991px) {
      background: black;
    }
  }
}

@media(max-width: 991px){
  .dropdown-menu_list-light{
    background-color: #fff;
    backdrop-filter: none;
    display: flex;
    flex-direction: column;
    align-items: center;

    ul{
    //  display: flex;
    //  flex-direction: column;
      //justify-content: center;

      li:not(:first-child){
        margin-top: 42px;
      }
    }
  }

  .open{
    left: 0;
    padding-bottom: 100px;
  }

  .logo {
    position: relative;
    z-index: 1;
  }
}
@media (min-width: 430px),
       (min-height: 895px){
  .open{
    padding-bottom: 150px;
  }
}
@media (min-width: 768px),
       (min-height: 1368px){
  .open{
    padding-bottom: 250px;
  }
}


</style>

